import request from '@/Network/Requests/request'
import Service from '@/Network/Services/Service'
import { FiltersNpsAnswers } from '@/Network/Types/Requests/NpsRequests'
import {
  NpsAnswerDetailResponse,
  ListNpsSubmissionsResponse
} from '@/Network/Types/Responses/NpsResponses'

export default class NpsAnswerService extends Service {
  prefix: string

  constructor() {
    super()
    this.prefix = '/nps/answers'
  }

  async getById(answerId: number): Promise<NpsAnswerDetailResponse> {
    const response = await request.get<NpsAnswerDetailResponse>(
      `${this.getCompletePath()}/${answerId}`
    )
    return response.data
  }

  async listSubmissions(filters?: FiltersNpsAnswers): Promise<ListNpsSubmissionsResponse> {
    try {
      const { data } = await request.get<ListNpsSubmissionsResponse>(
        `${this.getCompletePath()}/submissions`,
        filters
      )
      return data
    } catch (e) {
      throw this.handleError(e, 'Não foi possível carregar as respostas das enquetes.')
    }
  }
}
